export const ACTION_PERMISSIONS = {
    EDITAR_ACUERDO_VALOR_TURNO: "editar.acuerdo.valor.turno",
};

const decodeJWT = (token) => {
    try {
        const base64Url = token.split(".")[1];
        const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        const jsonPayload = decodeURIComponent(
            atob(base64)
                .split("")
                .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
                .join("")
        );
        return JSON.parse(jsonPayload);
    } catch (error) {
        console.error("Error decodificando el JWT:", error);
        return null;
    }
};

export const getActionPermissions = () => {
    const authToken = localStorage.getItem("authToken");
    const payload = authToken ? decodeJWT(authToken) : null;
    const permissions = payload?.permisosAcciones || payload?.permisos_acciones || [];

    if (!Array.isArray(permissions)) return [];

    return permissions
        .map((permission) => {
            if (typeof permission === "string") return permission;
            return permission?.codigo || permission?.code || "";
        })
        .filter(Boolean);
};

export const hasActionPermission = (permission) => {
    return getActionPermissions().includes(permission);
};
